import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import VideoModalOne from '../../components/video-modal-one'
import bg1 from '../../assets/images/charity/bg02.jpg'
import Partner from '../../components/partner'
import VideoModalTwo from '../../components/video-modal-two'
import aboutImg from '../../assets/images/charity/03.jpg'
import buyer from '../../assets/images/icon/buyer.svg'
import seller from '../../assets/images/icon/sales.svg'
import { charityData, charityFeature } from '../../data/data'
import about1 from '../../assets/images/ab01.jpg'
import about2 from '../../assets/images/ab02.jpg'
import about3 from '../../assets/images/ab03.jpg'
import about4 from '../../assets/images/ab04.jpg'
import Footer from '../../components/footer'

export default function IndexCharity() {
  return (
    <>
     <Navbar navLight={true}/> 

    <section className="bg-home d-flex align-items-center" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay" style={{opacity: '0.4'}}></div>
      <div className="container">
          <div className="row justify-content-center mt-5">
              <div className="col-lg-12 text-center">
                  <div className="title-heading mt-4">
                      <h1 className="heading text-white title-dark fw-normal mb-3"><span className="fw-bold">Charity is an act of a soft heart</span></h1>
                      <p className="para-desc mx-auto title-dark text-light">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="watch-video mt-4 pt-2">
                          <Link to="#" className="btn btn-primary me-2 rounded-pill"><i className="mdi mdi-heart-outline"></i> Get Started</Link>
                          <div className="watch-video mt-4 pt-2 d-inline-block">
                              <VideoModalOne textLight={true}/>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section py-5">
      <div className="container">
          <Partner/>
      </div>

      <div className="container mt-100 mt-60  ">
          <div className="row justify-content-center align-items-center">
              <div className="col-md-5 mt-4 mt-sm-0 pt-2 mb-md-4 pt-sm-0">
                  <div className="section-title">
                      <h5 className="text-primary">About Us</h5>
                      <h4 className="title mb-4">your help will be <br/> very useful for them</h4>
                  </div>
              </div>
              <div className="col-md-5 mt-md-4 mt-sm-0 pt-2 mb-4 pt-sm-0">
                  <p className="text-muted">There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space. Thesealternatives to the classic Lorem Ipsum texts are often amusing and tell short, funny or nonsensical stories.</p>
                  <Link to="#" className="btn btn-outline-primary rounded-pill mt-2">Read More <i className="mdi mdi-chevron-right"></i></Link>
              </div>
              <div className="col-lg-10">
                  <img src={aboutImg} className="img-fluid rounded-4 shadow-lg" alt=""/>
                  <VideoModalTwo/>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Two Parameters</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row justify-content-center">
              <div className="col-lg-8 col-md-10">
                  <div className="row">
                      <div className="col-md-6 mt-4 pt-2">
                          <div className="catagories p-4 border text-center rounded bg-white">
                              <img src={buyer} className="img-fluid avatar avatar-medium" alt=""/>
                              <div className="mt-3">
                                  <h5>Donate Money</h5>
                                  <p className="text-muted">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.</p>
                                  <Link to="#" className="btn btn-primary">Buy Now <i className="mdi mdi-chevron-right align-middle"></i></Link>
                              </div>
                          </div>
                      </div>
                      
                      <div className="col-md-6 mt-4 pt-2">
                          <div className="catagories p-4 border text-center rounded bg-white">
                              <img src={seller} className="img-fluid avatar avatar-medium" alt=""/>
                              <div className="mt-3">
                                  <h5>Donate Property</h5>
                                  <p className="text-muted">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.</p>
                                  <Link to="#" className="btn btn-primary">Sale Now <i className="mdi mdi-chevron-right align-middle"></i></Link>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-100">
          <div className="row justify-content-center align-items-center">
              <div className="col-lg-6 col-md-6 col-12 mt-4 pt-2">
                  <div className="section-title">
                      <div className="row g-3">
                        {charityFeature.map((item,index)=>{
                          let Icon = item.icon
                          return(
                              <div className="col-lg-6 col-md-12" key={index}>
                                  <div className="feature p-4 align-items-center shadow rounded bg-light">
                                      <Icon className="text-primary h1"/>
                                      <h5 className="mb-2 fw-bold">{item.title}</h5>
                                      <p className="text-muted m-0">{item.desc}</p>
                                  </div>
                              </div>
                          )
                        })}
                      </div>
                  </div>
              </div>

              <div className="col-lg-6 col-md-6 col-12 mt-4 pt-2 ps-md-4">
                  <div className="section-title">
                      <h5 className="text-primary">Categories</h5>
                      <h2 className="mb-4 title fw-bold">Get more getailded insights <br/> more easyily & more fast</h2>
                      <p className="text-muted">There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space. Thesealternatives to the classic Lorem Ipsum texts are often amusing and tell short, funny or nonsensical stories.</p>
                      <Link to="#" className="btn btn-primary rounded-pill mt-2">Donate Now</Link>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-md-6 order-1 order-md-2 text-end">
                  <div className="row align-items-center ms-lg-5">
                      <div className="col-lg-6 col-md-6 col-6">
                          <div className="row">
                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 overflow-hidden">
                                      <img src={about1} className="img-fluid" alt=""/>
                                  </div>
                              </div>

                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 shadow overflow-hidden">
                                      <img src={about2} className="img-fluid" alt=""/>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-6">
                          <div className="row">
                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 shadow overflow-hidden">
                                      <img src={about3} className="img-fluid" alt=""/>
                                  </div>
                              </div>

                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 shadow overflow-hidden">
                                      <img src={about4} className="img-fluid" alt=""/>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <div className="col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title">
                      <h4 className="title mb-4">Let's do it together. <br/><span className="text-primary">With our team member</span></h4>
                      <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <ul className="list-inline mb-0">
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I upgrade later on?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I port my data from another provider?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Are my food photos stored forever in the cloud?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Who foots the bill for that?</li>
                      </ul>
                      <div className="mt-4">
                          <Link to="#" className="text-primary">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="pt-5 pb-4" id="cause">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12">
                  <div className="section-title mb-4 pb-2 text-center">
                      <h4 className="title mb-4">Popular Causes</h4>
                      <p className="text-muted mx-auto para-desc mb-0">Splash your dream color Bring your home to lively Colors. We make it a priotity to offer flexible services to accomodate</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {charityData.map((item,index)=>{
              return(
                  <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                      <div className="shadow rounded">
                          <div className="image">
                              <img src={item.image} className="img-fluid rounded-top" alt=""/>
                          </div>

                          <div className=" p-4">
                              <Link to="#" className="text-dark title"><h5>{item.title}</h5></Link>
                              <p className="text-muted">{item.desc}</p>

                              <div className="progress-box mt-4 pt-4">
                                  <div className="progress">
                                      <div className="progress-bar position-relative bg-primary" style={{width:item.per}}>
                                          <div className="progress-value d-block text-muted h6">{item.per}</div>
                                      </div>
                                  </div>
                              </div>

                              <div className="fund-detail mt-4">
                                  <div className="float-end text-end">
                                      <h6 className="text-primary">Goal :</h6>
                                      <h6 className="mb-0 h6 fw-normal">{item.goal}</h6>
                                  </div>
                                  <div>
                                      <h6 className="text-primary">Raised :</h6>
                                      <h6 className="mb-0 h6 fw-normal">{item.raised}</h6>
                                  </div>
                              </div>

                              <div className="mt-3">
                                  <Link to="#" className="text-primary">Donate now <i className="mdi mdi-chevron-right align-middle"></i></Link>
                              </div>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>

          <div className="row justify-content-center mt-4 pt-2">
              <div className="col-12 text-center">
                  <Link to="#" className="btn btn-outline-primary ">All Causes <i className="mdi mdi-chevron-right align-middle"></i></Link>
              </div>
          </div>
      </div>
    </section>
    <Footer/>
    </>
  )
}
